(function ($) {

    var $layer;
    var $container;
    var $userList;
    var $userCount;
    var $msgBox;
    var $moreListSpinner;
    var _magazineNo;
    var _magazineAddress;
    var _isManage;
    var _userList;
    var _userCount;
    var _moreList;
    var _isLoading;

    var _init = function (magazineNo, magazineAddress, isManage) {
        _magazineNo = magazineNo;
        _magazineAddress = magazineAddress;
        _isManage = isManage;
        _userCount = 0;
        _userList = [];
        _moreList = true;

        $container = $(B.Util.getTemplate('popup-user-list.hbs', {
            title: _makeTitle(),
            showCount: true,
            count: _userCount
        }));
        $userList = $container.find('.user_list');
        $userCount = $container.find('.user_count');
        $moreListSpinner = $container.find('.spinner');

        $layer.append($container);

        $container.on('click', onClick);
        $layer.on('scroll', onScroll);
        $(window).on('keydown', onKeydown);
    };

    var _getActionButton = function (container, target) {
        var btn = $(target);
        while (!btn.is(container) && !btn.data('action')) {
            btn = btn.parent();
        }

        return btn;
    };

    var _show = function (magazineNo, magazineAddress, isManage) {
        $layer = B.Util.layer.showLayerBase();

        if (!$container) {
            _init(magazineNo, magazineAddress, isManage);
            _loadList();
        }

        if (_isManage != isManage) {
            _isManage = isManage;
            $userList.empty();
            _userCount = 0;
            _userList = [];
            _setMoreList(true);
            _loadList();
            $container.find('.tit_txt').html(_makeTitle());
        }

        $container.show();
    };

    var _makeTitle = function () {
        return _isManage ? '참여작가 관리' : '작가';
    };

    var _hide = function () {
        B.Util.layer.hideLayerBase();
        $container.hide();
    };

    var _loadList = function () {
        if (_isLoading || !_moreList) {
            return;
        }

        _isLoading = true;

        var lastCreateTime = 0;

        if (_userList && _userList.length > 0) {
            lastCreateTime = _userList[_userList.length - 1].createTime;
        }

        B.Util.ajax({
            url: B.Config.apiUrl + '/v1/magazine/' + _magazineNo + '/authors',
            method: 'GET',
            data: {
                createTime: lastCreateTime
            },
            success: function (data) {
                _setUserCount(data.data.totalCount);
                _appendUserList(data.data.list);
                _setMoreList(data.data.moreList);
                _isLoading = false;
                onScroll();
            },
            error: function () {
                _isLoading = false;
                _showMessage('오류가 발생했습니다.');
            }
        });
    };

    var _setUserCount = function (totalCount) {
        _userCount = totalCount;
        $userCount.text(_userCount);

        if (_userCount == 0) {
            $userList.hide();
            _showMessage('참여작가가 없습니다.');
        } else {
            $userList.show();
        }
    };

    var _setMoreList = function (moreList) {
        _moreList = moreList;

        if (_moreList) {
            $moreListSpinner.show();
        } else {
            $moreListSpinner.hide();
        }
    };

    var _appendUserList = function (list) {
        for (var i = 0; i < list.length; i++) {
            _userList.push(list[i]);
            $userList.append(_makeUserView(list[i]));
        }
    };

    var _removeUserView = function (user) {
        $userList.find('li[data-userid=' + user.userId + ']').remove();
    };

    var _updateUserView = function (user) {
        var view = _makeUserView(user);
        $userList.find('li[data-userid=' + user.userId + ']').html(view.html());
    };

    var _makeUserView = function (user) {
        return $(B.Util.getTemplate('popup-magazine-author-item.hbs', {
            author: user,
            isManage: _isManage,
            userId: B.User.userId
        }));
    };

    var _findUserByUserId = function (userId, callback) {
        var i;
        for (i = 0; i < _userList.length; i++) {
            if (_userList[i].userId == userId) {
                callback(i, _userList[i]);
                return;
            }
        }
    };

    var _deleteAuthor = function (userId) {

        if (!confirm('매거진에서 참여작가를 탈퇴시키면 작가가 보낸 글도 모두 제외됩니다. 계속 진행하시겠습니까?')) {
            return false;
        }

        B.Util.ajax({
            url: B.Config.apiUrl + '/v1/magazine/' + _magazineNo + '/author/' + userId,
            method: 'DELETE',
            success: function (data) {
                _findUserByUserId(userId, function (index, user) {
                    _userList.splice(index, 1);
                    _setUserCount(_userCount - 1);
                    _removeUserView(user);
                });
            },
            error: function () {
                _showMessage('오류가 발생했습니다.');
            }
        });
    };

    var _followUser = function (userId) {
        B.Util.ajax({
            url: B.Config.apiUrl + '/v1/subscription/user/follow',
            method: 'POST',
            data: {
                writerUserId: userId
            },
            success: function (data) {
                _findUserByUserId(userId, function (index, user) {
                    user.myWriter = true;
                    _updateUserView(user);
                });
            },
            error: function () {
                _showMessage('오류가 발생했습니다.');
            }
        });
    };

    var _unfollowUser = function (userId) {
        B.Util.ajax({
            url: B.Config.apiUrl + '/v1/subscription/user/unfollow/@@' + userId,
            method: 'DELETE',
            success: function (data) {
                _findUserByUserId(userId, function (index, user) {
                    user.myWriter = false;
                    _updateUserView(user);
                });
            },
            error: function () {
                _showMessage('오류가 발생했습니다.');
            }
        });
    };

    var _showMessage = function (message) {
        if (!$msgBox) {
            $msgBox = $("<div class='message'></div>");
            $container.append($msgBox);
        }

        if (message) {
            $msgBox.html(B.Util.getTemplate('alert.hbs', {
                alertWrapTitle: message
            }));
            $msgBox.show();
            $userList.hide();
            $moreListSpinner.hide();
        } else {
            $msgBox.hide();
        }
    };

    var onClick = function (e) {
        if (!$container.is(':visible')) {
            return;
        }

        var btn = _getActionButton(this, e.target);
        var action = btn.data('action');
        var userId = btn.data('userid');

        if (action != null) {
            e.preventDefault();
        }

        if (action == 'close') {
            _hide();
        } else if (action == 'deleteAuthor') {
            _deleteAuthor(userId);
        } else if (action == 'follow') {
            _followUser(userId);
        } else if (action == 'unfollow') {
            _unfollowUser(userId);
        }
    };

    var onScroll = function (e) {
        if (!$container.is(':visible')) {
            return;
        }

        _adjustHeader();

        if (!_moreList) {
            return;
        }

        var top = $moreListSpinner.offset().top - $layer.offset().top;
        var appearTop = $layer.height();

        if (appearTop > top) {
            _loadList();
        }
    };

    var _adjustHeader = function () {
        var top = $layer.scrollTop();
        var fixedClass = 'fixed';

        if (top > 0) {
            $container.addClass(fixedClass);
        } else {
            $container.removeClass(fixedClass);
        }
    };

    var onKeydown = function (e) {
        if (!$container.is(':visible')) {
            return;
        }

        if (e.keyCode == 27) {
            _hide();
            e.preventDefault();
        }
    };

    B.Magazine.Author = {
        show: function (_magazineNo, magazineAddress, isManage) {
            _show(_magazineNo, magazineAddress, isManage);
        },
        hide: function () {
            _hide();
        }
    };

})(jQuery);
